import * as angular from 'angular';

import ApiModule from '../api/api.module';

import { AptitudeNavComponent } from './aptitudeNav.component';
import AptitudeNavService from './aptitudeNav.service';
import GapDirective from './gap.directive';
import GutterDirective from './gutter.directive';
import NavButtonDirective from './navButton.directive';
import NavDownloadDirective from './navDownload.directive';
import NavItemDirective from './navItem.directive';
import NavLinkDirective from './navLink.directive';
import SpinnerDirective from './spinner.directive';
import UtilModule from '../core/util/util.module';
import { ApplicationRoutesNgService } from '../core/routeGuard/applicationRoutesNg.service';

// TODO: Import the api module for the aptitudeNav directive
export default angular
  .module('Navigation', [ApiModule, UtilModule, 'ngSanitize'])
  .component('aptitudeNav', AptitudeNavComponent)
  .service('AptitudeNav', AptitudeNavService)
  .service('applicationRoutesNgService', ApplicationRoutesNgService)
  .directive('gap', GapDirective)
  .directive('gutter', GutterDirective)
  .directive('navButton', NavButtonDirective)
  .directive('navDownload', NavDownloadDirective)
  .directive('navItem', NavItemDirective)
  .directive('navLink', NavLinkDirective)
  .directive('spinner', SpinnerDirective).name;
